// components/HelpModal/ResourcesTab.jsx
import React from "react";
import "./ResourcesTab.css";

const ResourcesTab = () => {
  const resources = [
    {
      title: "کانال two_sub در تلگرام",
      description: "فیلم و سریال با دو زیرنویس همزمان",
      url: "https://t.me/two_sub",
      icon: "fa-telegram-plane",
      color: "#0088cc",
    },
    // {
    //   title: "کانال LanguageLearningWithMovie",
    //   description: "در پیام‌رسان‌های داخلی (بله، روبیکا و ایتا)",
    //   url: "https://t.me/two_sub",
    //   icon: "fa-film",
    //   color: "#e91e63",
    //   isInternal: true,
    // },
  ];

  return (
    <div className="resources-tab">
      <div className="resources-intro">
        <div className="resources-intro-icon">
          <i className="fas fa-info-circle"></i>
        </div>
        <p>
          یکی از مهم‌ترین ویژگی‌های برنامه اوملنگ عدم وابستگی به منبع انتشار
          فیلم و سریال است، این به این معنی است که از هر منبعی شما می‌توانید
          فیلم و سریال را دانلود کرده و با دو زیرنویس تماشا کنید.
        </p>
        <p>
          شما حتی می‌توانید فیلم‌هایی که دوستان شما دانلود کرده‌اند را از طریق
          فلش درایو و هارد یا نرم‌افزارهای اشتراک فایل در گوشی، این فیلم‌ها را
          بر روی گوشی و کامپیوتر خود منتقل کرده و به راحتی اقدام به تماشای فیلم
          و سریال کنید.
        </p>
      </div>

      <div className="resources-subtitle">
        <p>
          برخی از منابع فرایند پیدا نمودن دو زیرنویس را در برنامه آسان نموده‌اند
          که در پایین این منابع را جداگانه معرفی می‌کنیم:
        </p>
      </div>

      <div className="resources-cards">
        {resources.map((resource, index) => (
          <a
            key={index}
            href={resource.url}
            target="_blank"
            rel="noopener noreferrer"
            className="resource-card"
            style={{ borderColor: resource.color + "40" }}
          >
            <div
              className="resource-card-icon"
              style={{
                background: resource.color + "20",
                color: resource.color,
              }}
            >
              <i className={`fab ${resource.icon}`}></i>
            </div>
            <div className="resource-card-info">
              <h4>{resource.title}</h4>
              <p>{resource.description}</p>
            </div>
            <div className="resource-card-arrow">
              <i className="fas fa-arrow-left"></i>
            </div>
          </a>
        ))}
      </div>

      <div className="resources-note">
        <p>با کلیک بر روی هر کدام از لینک‌های بالا صفحه مورد نظر باز می‌شود.</p>
      </div>
    </div>
  );
};

export default ResourcesTab;
